import React, { useState, useEffect, useRef } from 'react'
import { searchChert, fetchChertList, updateChert, addCandidate, checkPassport, fetchLocations, updateCandidate } from '../lib/api'

function statusLabel(c) {
  if (c.is_chert) return null
  if (c.moscow_completed || c.partner_completed) return { text: 'завершён', color: '#8a6d3b', bg: '#fff8e1' }
  if (c.archived) return { text: 'архив', color: '#777', bg: '#f0f0ec' }
  return { text: 'активный', color: '#27500A', bg: '#f4f9ef' }
}

function ChertBadge() {
  return (
    <span style={{ background: '#fdecea', color: '#c0392b', borderRadius: 5, padding: '2px 8px', fontSize: 11, fontWeight: 700, border: '1px solid #f5c6cb' }}>
      😈 ЧЁРТ
    </span>
  )
}

function CandidateRow({ c, onMarkChert, onUnmark }) {
  const [expanded, setExpanded] = useState(false)
  const status = statusLabel(c)
  return (
    <div style={{ border: `1px solid ${c.is_chert ? '#f5c6cb' : '#e8e8e5'}`, borderRadius: 8, padding: '10px 14px', background: c.is_chert ? '#fff8f8' : '#fff', marginBottom: 8 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
            <span style={{ fontWeight: 700, fontSize: 14 }}>{c.name}</span>
            {c.is_chert && <ChertBadge />}
            {status && <span style={{ fontSize: 11, padding: '1px 7px', borderRadius: 4, background: status.bg, color: status.color, border: `1px solid ${status.color}33` }}>{status.text}</span>}
          </div>
          <div style={{ fontSize: 12, color: '#666', marginTop: 3, display: 'flex', gap: 12, flexWrap: 'wrap' }}>
            {c.passport && <span>📄 {c.passport}</span>}
            {c.phone && <span>📞 {c.phone}</span>}
            {c.responsible_name && <span>👤 {c.responsible_name}</span>}
          </div>
          {c.is_chert && c.chert_reason && (
            <div style={{ marginTop: 6, fontSize: 12, color: '#c0392b', background: '#fdecea', borderRadius: 5, padding: '4px 8px' }}>
              ⚠️ {c.chert_reason}
            </div>
          )}
        </div>
        <div style={{ display: 'flex', gap: 6, flexShrink: 0 }}>
          {c.is_chert
            ? <button onClick={() => onUnmark(c)} style={{ fontSize: 11, padding: '4px 10px', borderRadius: 6, border: '1px solid #ccc', background: '#f8f8f8', cursor: 'pointer', color: '#555' }}>Снять метку</button>
            : <button onClick={() => onMarkChert(c)} style={{ fontSize: 11, padding: '4px 10px', borderRadius: 6, border: '1px solid #e57373', background: '#fdecea', cursor: 'pointer', color: '#c0392b', fontWeight: 600 }}>😈 Отметить</button>
          }
          {c.is_chert && <button onClick={() => setExpanded(v => !v)} style={{ fontSize: 11, padding: '4px 10px', borderRadius: 6, border: '1px solid #ddd', background: '#f5f5f5', cursor: 'pointer' }}>✏️</button>}
        </div>
      </div>
      {c.is_chert && expanded && (
        <EditReasonInline c={c} onSave={(reason) => { onMarkChert({ ...c, chert_reason: reason }); setExpanded(false) }} onClose={() => setExpanded(false)} />
      )}
    </div>
  )
}

function EditReasonInline({ c, onSave, onClose }) {
  const [reason, setReason] = useState(c.chert_reason || '')
  return (
    <div style={{ marginTop: 10, display: 'flex', gap: 8 }}>
      <input value={reason} onChange={e => setReason(e.target.value)} placeholder="Причина..."
        style={{ flex: 1, padding: '6px 10px', borderRadius: 6, border: '1px solid #f5c6cb', fontSize: 13 }} autoFocus />
      <button onClick={() => onSave(reason)} style={{ padding: '6px 14px', borderRadius: 6, background: '#c0392b', color: '#fff', border: 'none', cursor: 'pointer', fontSize: 13 }}>Сохранить</button>
      <button onClick={onClose} style={{ padding: '6px 10px', borderRadius: 6, background: '#f0f0ec', border: 'none', cursor: 'pointer', fontSize: 13 }}>Отмена</button>
    </div>
  )
}

function MarkModal({ candidate, onClose, onConfirm }) {
  const [reason, setReason] = useState('')
  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal modal-sm" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h2>😈 Отметить как черта</h2>
          <button className="close-btn" onClick={onClose}>✕</button>
        </div>
        <div style={{ padding: '16px 20px', display: 'flex', flexDirection: 'column', gap: 12 }}>
          <div style={{ fontWeight: 600, fontSize: 14 }}>{candidate.name}</div>
          {candidate.passport && <div style={{ fontSize: 12, color: '#888' }}>Паспорт: {candidate.passport}</div>}
          <div>
            <div style={{ fontSize: 12, color: '#888', marginBottom: 6 }}>Причина (что натворил)</div>
            <textarea value={reason} onChange={e => setReason(e.target.value)} rows={4}
              placeholder="Например: 3 раза посадили на автобус — не поехал. Взял аванс и пропал..."
              style={{ width: '100%', padding: '8px 10px', borderRadius: 8, border: '1px solid #f5c6cb', fontSize: 13, resize: 'vertical', boxSizing: 'border-box' }} autoFocus />
          </div>
        </div>
        <div className="modal-actions">
          <button className="btn btn-outline" onClick={onClose}>Отмена</button>
          <button className="btn btn-danger" onClick={() => onConfirm(reason)} disabled={!reason.trim()}>
            Подтвердить
          </button>
        </div>
      </div>
    </div>
  )
}

function QuickAddModal({ onClose, onAdded }) {
  const [name, setName] = useState('')
  const [phone, setPhone] = useState('')
  const [passport, setPassport] = useState('')
  const [reason, setReason] = useState('')
  const [saving, setSaving] = useState(false)
  const [passportWarn, setPassportWarn] = useState(null)

  async function handleSave() {
    if (!name.trim()) return
    setSaving(true)
    try {
      await addCandidate({ name: name.trim(), phone: phone.trim() || null, passport: passport.trim() || null, is_chert: true, chert_reason: reason.trim() || null, status: 'ожидает', workspace: 'main' })
      onAdded()
      onClose()
    } catch(e) { alert('Ошибка: ' + e.message) } finally { setSaving(false) }
  }

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal modal-sm" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h2>😈 Добавить черта</h2>
          <button className="close-btn" onClick={onClose}>✕</button>
        </div>
        <div style={{ padding: '16px 20px', display: 'flex', flexDirection: 'column', gap: 12 }}>
          <div>
            <div style={{ fontSize: 12, color: '#888', marginBottom: 5 }}>ФИО *</div>
            <input value={name} onChange={e => setName(e.target.value)} placeholder="Имя кандидата"
              style={{ width: '100%', padding: '8px 10px', borderRadius: 8, border: '1px solid #e0e0dc', fontSize: 13, boxSizing: 'border-box' }} autoFocus />
          </div>
          <div>
            <div style={{ fontSize: 12, color: '#888', marginBottom: 5 }}>Телефон</div>
            <input value={phone} onChange={e => setPhone(e.target.value)} placeholder="+XXX XX XXX XXXX"
              style={{ width: '100%', padding: '8px 10px', borderRadius: 8, border: '1px solid #e0e0dc', fontSize: 13, boxSizing: 'border-box' }} />
          </div>
          <div>
            <div style={{ fontSize: 12, color: '#888', marginBottom: 5 }}>Номер паспорта</div>
            <input value={passport}
              onChange={e => { setPassport(e.target.value); setPassportWarn(null) }}
              onBlur={async e => {
                const p = e.target.value.trim()
                if (!p || p.length < 3) { setPassportWarn(null); return }
                try {
                  const found = await checkPassport(p)
                  setPassportWarn(found || null)
                } catch { setPassportWarn(null) }
              }}
              placeholder="AB1234567"
              style={{ width: '100%', padding: '8px 10px', borderRadius: 8, border: `1px solid ${passportWarn ? (passportWarn.is_chert ? '#f5c6cb' : '#ffe082') : '#e0e0dc'}`, fontSize: 13, boxSizing: 'border-box' }} />
            {passportWarn && (
              <div style={{ marginTop: 4, padding: '6px 10px', borderRadius: 6, fontSize: 12,
                background: passportWarn.is_chert ? '#fdecea' : '#fff8e1',
                border: `1px solid ${passportWarn.is_chert ? '#f5c6cb' : '#ffe082'}`,
                color: passportWarn.is_chert ? '#c0392b' : '#7a5800' }}>
                {passportWarn.is_chert
                  ? `⚠️ ВНИМАНИЕ: этот кандидат уже в списке чертей! ${passportWarn.chert_reason ? '— ' + passportWarn.chert_reason : ''}`
                  : `⚠️ Кандидат с таким паспортом уже существует: ${passportWarn.name}`}
              </div>
            )}
          </div>
          <div>
            <div style={{ fontSize: 12, color: '#888', marginBottom: 5 }}>Причина (что натворил)</div>
            <textarea value={reason} onChange={e => setReason(e.target.value)} rows={3}
              placeholder="Например: взял аванс и пропал, 3 раза срывал отъезд..."
              style={{ width: '100%', padding: '8px 10px', borderRadius: 8, border: '1px solid #f5c6cb', fontSize: 13, resize: 'vertical', boxSizing: 'border-box' }} />
          </div>
        </div>
        <div className="modal-actions">
          <button className="btn btn-outline" onClick={onClose}>Отмена</button>
          <button className="btn btn-danger" onClick={handleSave} disabled={saving || !name.trim()}>
            {saving ? 'Сохранение...' : '😈 Добавить'}
          </button>
        </div>
      </div>
    </div>
  )
}

export default function ChertiPage() {
  const [query, setQuery] = useState('')
  const [searchResults, setSearchResults] = useState([])
  const [searching, setSearching] = useState(false)
  const [chertList, setChertList] = useState([])
  const [loadingList, setLoadingList] = useState(true)
  const [markModal, setMarkModal] = useState(null)
  const [showQuickAdd, setShowQuickAdd] = useState(false)
  const [unmarkCandidate, setUnmarkCandidate] = useState(null)
  const [locations, setLocations] = useState([])
  const [selectedLocationId, setSelectedLocationId] = useState('')
  const [unmarking, setUnmarking] = useState(false)
  const debounceRef = useRef(null)

  useEffect(() => {
    loadChertList()
    fetchLocations().then(locs => setLocations(locs.filter(l => l.id !== '5948ab6f'))).catch(() => {})
  }, [])

  async function loadChertList() {
    setLoadingList(true)
    try { setChertList(await fetchChertList()) } catch(e) {} finally { setLoadingList(false) }
  }

  function handleQueryChange(e) {
    const q = e.target.value
    setQuery(q)
    clearTimeout(debounceRef.current)
    if (!q.trim() || q.trim().length < 2) { setSearchResults([]); return }
    debounceRef.current = setTimeout(async () => {
      setSearching(true)
      try { setSearchResults(await searchChert(q.trim())) } catch(e) {} finally { setSearching(false) }
    }, 300)
  }

  async function handleMark(candidate, reason) {
    try {
      await updateChert(candidate.id, true, reason)
      setMarkModal(null)
      if (query.trim().length >= 2) setSearchResults(prev => prev.map(c => c.id === candidate.id ? { ...c, is_chert: true, chert_reason: reason } : c))
      await loadChertList()
    } catch(e) { alert('Ошибка: ' + e.message) }
  }

  function handleUnmark(candidate) {
    setUnmarkCandidate(candidate)
    setSelectedLocationId('')
  }

  async function confirmUnmark() {
    if (!selectedLocationId || !unmarkCandidate) return
    setUnmarking(true)
    try {
      await updateChert(unmarkCandidate.id, false, null)
      await updateCandidate(unmarkCandidate.id, { location_id: selectedLocationId, status: 'ожидает', archived: false })
      if (query.trim().length >= 2) setSearchResults(prev => prev.map(c => c.id === unmarkCandidate.id ? { ...c, is_chert: false, chert_reason: null } : c))
      setUnmarkCandidate(null)
      setSelectedLocationId('')
      await loadChertList()
    } catch(e) { alert('Ошибка: ' + e.message) } finally { setUnmarking(false) }
  }

  return (
    <div style={{ maxWidth: 760, margin: '0 auto', padding: '24px 16px' }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 20, flexWrap: 'wrap', gap: 10 }}>
        <h1 style={{ fontSize: 22, fontWeight: 800, margin: 0 }}>😈 Список чертей</h1>
        <button onClick={() => setShowQuickAdd(true)}
          style={{ padding: '8px 16px', borderRadius: 8, background: '#c0392b', color: '#fff', border: 'none', cursor: 'pointer', fontWeight: 600, fontSize: 13 }}>
          + Добавить черта
        </button>
      </div>

      {/* Поиск */}
      <div style={{ position: 'relative', marginBottom: 24 }}>
        <input
          value={query}
          onChange={handleQueryChange}
          placeholder="🔍 Поиск по имени, паспорту или телефону..."
          style={{ width: '100%', padding: '12px 16px', borderRadius: 10, border: '1px solid #ddd', fontSize: 14, boxSizing: 'border-box', boxShadow: '0 1px 4px #0001' }}
        />
        {searching && <div style={{ position: 'absolute', right: 14, top: '50%', transform: 'translateY(-50%)', fontSize: 12, color: '#aaa' }}>Поиск...</div>}
      </div>

      {/* Результаты поиска */}
      {query.trim().length >= 2 && (
        <div style={{ marginBottom: 32 }}>
          <div style={{ fontSize: 12, color: '#888', marginBottom: 10, fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.5 }}>
            Результаты поиска {searchResults.length > 0 ? `(${searchResults.length})` : ''}
          </div>
          {searchResults.length === 0 && !searching && (
            <div style={{ color: '#aaa', fontSize: 13, padding: '16px 0' }}>Ничего не найдено</div>
          )}
          {searchResults.map(c => (
            <CandidateRow key={c.id} c={c}
              onMarkChert={c2 => c2.chert_reason !== undefined ? handleMark(c2, c2.chert_reason) : setMarkModal(c2)}
              onUnmark={handleUnmark} />
          ))}
        </div>
      )}

      {/* Список чертей */}
      <div>
        <div style={{ fontSize: 12, color: '#888', marginBottom: 10, fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.5 }}>
          Все черти {chertList.length > 0 ? `(${chertList.length})` : ''}
        </div>
        {loadingList && <div style={{ color: '#aaa', fontSize: 13 }}>Загрузка...</div>}
        {!loadingList && chertList.length === 0 && (
          <div style={{ color: '#aaa', fontSize: 13, padding: '16px 0' }}>Список пуст — пока всё чисто 😇</div>
        )}
        {chertList.map(c => (
          <CandidateRow key={c.id} c={c}
            onMarkChert={c2 => c2.chert_reason !== undefined ? handleMark(c2, c2.chert_reason) : setMarkModal(c2)}
            onUnmark={handleUnmark} />
        ))}
      </div>

      {markModal && (
        <MarkModal candidate={markModal} onClose={() => setMarkModal(null)} onConfirm={reason => handleMark(markModal, reason)} />
      )}
      {showQuickAdd && (
        <QuickAddModal onClose={() => setShowQuickAdd(false)} onAdded={loadChertList} />
      )}

      {unmarkCandidate && (
        <div className="modal-backdrop" onClick={() => setUnmarkCandidate(null)}>
          <div className="modal modal-sm" onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <h2>Снять метку</h2>
              <button className="close-btn" onClick={() => setUnmarkCandidate(null)}>✕</button>
            </div>
            <div style={{ padding: '16px 20px', display: 'flex', flexDirection: 'column', gap: 12 }}>
              <div style={{ fontSize: 13, color: '#444' }}>
                Выберите локацию для <strong>{unmarkCandidate.name}</strong>. Кандидат появится на главной доске со статусом «ожидает».
              </div>
              <div>
                <div style={{ fontSize: 12, color: '#888', marginBottom: 6 }}>Локация *</div>
                <select
                  value={selectedLocationId}
                  onChange={e => setSelectedLocationId(e.target.value)}
                  style={{ width: '100%', padding: '8px 10px', borderRadius: 8, border: `1px solid ${!selectedLocationId ? '#e57373' : '#e0e0dc'}`, fontSize: 13, background: '#fff' }}>
                  <option value="">— выберите локацию —</option>
                  {locations.map(l => (
                    <option key={l.id} value={l.id}>{l.name}</option>
                  ))}
                </select>
                {!selectedLocationId && (
                  <div style={{ marginTop: 4, fontSize: 12, color: '#c0392b' }}>Обязательно выберите локацию</div>
                )}
              </div>
            </div>
            <div className="modal-actions">
              <button className="btn btn-outline" onClick={() => setUnmarkCandidate(null)}>Отмена</button>
              <button className="btn btn-primary" onClick={confirmUnmark} disabled={!selectedLocationId || unmarking}>
                {unmarking ? 'Сохранение...' : 'Снять метку'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
